import { createSelector } from "reselect";
// import lodash from "lodash";

// const loadingState = (state, props) => {
//   return state.groups.get("loading");
// };
// export const loadingSelector = () =>
//   createSelector([loadingState], (loading) => loading);

// const errorState = (state, props) => state.groups.get("error");

// export const errorSelector = () =>
//   createSelector([errorState], (error) => error);

const groupsState = (state, props) =>
  state.groups.get("groups");

export const groupsSelector = () =>
  createSelector([groupsState], (groups) => groups);

// const groupsShowState = (state, props) => {

//   const groups = state.groups.get("groups");

//   if (groups.size === 0) {
//     return {};
//   } else {
//     const id = parseInt(props.match.params.id);
//     const idx = lodash.findIndex(groups, {
//       id: id,
//     });
//     if (idx !== -1) {
//       return groups[idx];
//     }
//     return {};
//   }
// };

// export const groupsShowSelector = () =>
//   createSelector([groupsShowState], (groups) => groups);

// const paginationState = (state, props) => {
//   const pageObj = {};
//   pageObj.page = state.groups.get("page");
//   pageObj.totalPages = state.groups.get("total_pages");

//   return pageObj;
// };

// export const paginationSelector = () =>
//   createSelector([paginationState], (pageObj) => pageObj);

// export const usersState = (state, props) => {
//     return state.users.get("users");
// };